import { useEffect } from "react";
import {
  capitalizeFirstLetter,
  convertDate,
  copyText,
  formatUrl,
  scrollWindowTop,
} from "../../../utils/Common/Constant";
import { useTranslation } from "react-i18next";
import LinkedinIconSm from "../../../utils/Images/LinkedinIconSm";
import GithubIconSm from "../../../utils/Images/GithubIconSm";
import { Bullets } from "ui-components";
import PhoneIcon from "../../../utils/Images/PhoneIcon";
import UserImage from "../../../utils/Images/UserImage";
import EmailIcon from "../../../utils/Images/EmailIcon";

interface ResourceDetailsProps {
  contractDetails: any;
}
const ResourcesList = ({ contractDetails }: ResourceDetailsProps) => {
  const { t } = useTranslation();
  useEffect(() => {
    scrollWindowTop();
  }, []);
  return (
    <div className="resourcesDetailsSec">
      <div className="contractVendorDetail">
        <div className="profileMeta">
          <div className="row">
            <div className="col-md-12">
              <div className="contactInfoWrapper">
                <div className="profileHeader mb-4">
                  <div className="profileInfo">
                    <div className="profileAvatar">
                      <img
                        src={
                          contractDetails?.profilePic ? (
                            contractDetails?.profilePic
                          ) : (
                            <UserImage />
                          )
                        }
                        alt=""
                      />
                    </div>
                    <div className="basicDetails">
                      <div className="nameTag">
                        <span className="name">
                          {contractDetails?.applicantFirstName ||
                          contractDetails?.applicantLastName
                            ? contractDetails?.applicantFirstName +
                              " " +
                              contractDetails?.applicantLastName
                            : "-"}
                        </span>
                      </div>
                      <div className="contactInfoWrapper">
                        <div className="contactInfo">
                          <span>
                            <EmailIcon />
                            <div
                              className="cursorPointer"
                              onClick={() =>
                                copyText(contractDetails?.applicantEmailId)
                              }
                            >
                              {contractDetails?.applicantEmailId
                                ? contractDetails?.applicantEmailId
                                : "-"}
                            </div>
                          </span>
                          <span>
                            <PhoneIcon />
                            <div>
                              {contractDetails?.applicantMobile
                                ? contractDetails?.applicantMobile
                                : "-"}
                            </div>
                          </span>
                        </div>
                        <div className="bulletSec mt-2">
                          {contractDetails?.applicantSkills?.map(
                            (item: any, ind: number) => {
                              return (
                                <div key={ind}>
                                  <Bullets
                                    skillName={capitalizeFirstLetter(
                                      item?.skillName,
                                    )}
                                  />
                                </div>
                              );
                            },
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("RESOURCE.RESOURCE_TYPE")}</p>
                <h5 className="metaValue">
                  {contractDetails.applicantResourceType
                    ? contractDetails.applicantResourceType
                    : "?"}
                </h5>
              </div>
            </div>
            <div className="col-md-4">
              <div className="mb-5">
                <p className="metaLabel">{t("RESOURCE.SOCIAL_LINKS")}</p>
                <h5 className="metaValue">
                  {contractDetails?.githubUrl ||
                  contractDetails?.linkedInUrl ? (
                    <div className="socialIcons">
                      {contractDetails?.linkedInUrl && (
                        <span>
                          <a
                            href={formatUrl(contractDetails?.linkedInUrl)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <LinkedinIconSm />
                          </a>
                        </span>
                      )}
                      {contractDetails?.githubUrl && (
                        <span>
                          <a
                            href={formatUrl(contractDetails?.githubUrl)}
                            target="_blank"
                            rel="noreferrer"
                          >
                            <GithubIconSm />
                          </a>
                        </span>
                      )}
                    </div>
                  ) : (
                    "-"
                  )}
                </h5>
              </div>
            </div>

            <div className="col-md-4">
              <div className="w-100 mb-5">
                <p className="metaLabel">{t("RESOURCE.TOTAL_EXPERIENCE")}</p>
                <h5 className="metaValue">
                  {contractDetails?.applicantTotalExperience &&
                    contractDetails?.applicantTotalExperience}
                  &nbsp;
                  {t("GENERAL.YEARS")}
                </h5>
              </div>
            </div>

            <div className="col-md-4">
              <div className="mb-5">
                <p className="metaLabel">{t("RESOURCE.ADDED_DATE")}</p>
                <h5 className="metaValue">
                  {convertDate(contractDetails?.createdAt, false, true)}
                </h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResourcesList;
